import React, { useState } from 'react';

import { Dialog } from 'primereact/dialog';


const VisualizadorPDF = ({ arquivo, visivel, onHide }) => {
    const [numPages, setNumPages] = useState(null);
    const [visible, setVisible] = useState(false);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const renderOptionButton = (option) =>{
        switch(option){
            case 'centermaq':

            return
            case 'datacount':

            return

            default:

            return                
        }
    }


    return (
        <>
        <span className='link' onClick={()=>setVisible(true)}>Ajuda</span>
        <Dialog header="Datacount" visible={visible} style={{ width: '70vw', }} onHide={()=>setVisible(false)} maximizable>
             <iframe src={arquivo} style={{ width: '100%', height: '70vh' }} title="Visualizador PDF"/>
        </Dialog>
        </>
    );
};

export default VisualizadorPDF;
